module.exports = __webpack_public_path__ + "media/images/img-database-805d751354553e7df22a83f065572dc8.jpg";